import styled from '@emotion/styled';
import { colors } from 'theme/colors';
import { css } from '@mui/material';

interface IStyledWrapper {
  backgroundColor: string;
  borderColor: string;
}

const StyledWrapper = styled.div<IStyledWrapper>`
  display: flex;
  align-items: center;
  min-height: 28px;
  padding: 16px;
  border: 1px solid ${colors.error15};
  border-radius: 4px;
  ${(props: IStyledWrapper) =>
    css`
      background-color: ${props.backgroundColor};
      border: 1px solid ${props.borderColor};
    `}
`;
interface IStyledIconWrapper {
  iconBackgroundColor: string;
}

const StyledIconWrapper = styled.div<IStyledIconWrapper>`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 28px;
  height: 28px;
  border-radius: 26px;
  ${(props: IStyledIconWrapper) =>
    css`
      background-color: ${props.iconBackgroundColor};
    `}
`;
const StyledIconCloseWrapper = styled.div<IStyledIconWrapper>`
  display: flex;
  position: absolute;
  right: 16px;
  justify-content: center;
  align-items: center;
  min-width: 28px;
  height: 28px;
  cursor: pointer;
  .MuiSvgIcon-root {
    ${(props: IStyledIconWrapper) =>
      css`
        color: ${props.iconBackgroundColor};
      `}
  }
`;

export { StyledWrapper, StyledIconWrapper, StyledIconCloseWrapper };
